import { CanMatchFn } from '@angular/router';

/**
 * [AE-4721] eh.live is the address people type into a TV remote, so the
 * bare domain has to land on the pairing screen. Everywhere else the
 * root belongs to the authenticated dashboard.
 */

const TV_HOSTS = new Set(['eh.live', 'www.eh.live']);

export function isTvHost(hostname: string): boolean {
  return TV_HOSTS.has(hostname.trim().toLowerCase());
}

/**
 * True for the public floor-TV surface: eh.live (any path) or /tv on
 * the dialer host. Used by main.ts to fork the lightweight TV shell, and
 * by the dialer shell to skip microphone / WebRTC boot, without touching
 * agent or admin routes.
 */
export function isLeaderboardTvSurface(
  hostname: string = typeof window !== 'undefined'
    ? window.location.hostname
    : '',
  pathname: string = typeof window !== 'undefined'
    ? window.location.pathname
    : ''
): boolean {
  if (isTvHost(hostname)) {
    return true;
  }
  const path = pathname.split(/[?#]/, 1)[0] ?? '';
  return path === '/tv' || path.startsWith('/tv/');
}

export const tvHostGuard: CanMatchFn = () => isTvHost(window.location.hostname);
